import React from 'react';
import { Helmet } from 'react-helmet-async';
import "./sustainability.css";
import { FaLeaf, FaBuilding, FaSeedling } from "react-icons/fa";
import nutrientTable from "../../components/assets/nutitiontable.jpg";

function Sustainability() {
  return (
    <div>
      <Helmet>
        <title>Sustainability - Enteeon</title>
        <meta name="description" content="Discover how Enteeon transforms organic waste into sustainable products using black soldier fly technology, promoting a circular economy and reducing environmental impact." />
        <meta name="keywords" content="sustainability, organic waste recycling, black soldier fly, circular economy, eco-friendly farming, Enteeon" />
        <meta property="og:title" content="Sustainability - Enteeon" />
        <meta property="og:description" content="Discover how Enteeon transforms organic waste into sustainable products using black soldier fly technology, promoting a circular economy and reducing environmental impact." />
        <meta property="og:image" content="https://enteeon.com/assets/home/bg-sustain.jpg" />
        <meta property="og:url" content="https://enteeon.com/sustainability" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sustainability - Enteeon" />
        <meta name="twitter:description" content="Discover how Enteeon transforms organic waste into sustainable products using black soldier fly technology, promoting a circular economy and reducing environmental impact." />
        <meta name="twitter:image" content="https://enteeon.com/assets/home/bg-sustain.jpg" />
      </Helmet>
         <div className="help-planet-section">
      <div className="container text-center py-4">
        <h2 className="text-muted fw-bold">How We Help the Planet.</h2>
        <p className="description">
          At Enteeon, we believe every bit of waste has value. By converting organic waste into
          high-value products, we reduce landfill dependency and lower greenhouse gas emissions.
        </p>
        <h3 className="text-muted fw-bold mt-4" style={{paddingBottom:"50px",}}>The Bigger Picture.</h3>
        <div className="row text-center mt-3">
          <div className="col-md-4">
            <FaLeaf size={50} className="icon" />
            <p>70% lower carbon emissions.</p>
          </div>
          <div className="col-md-4">
            <FaBuilding size={50} className="icon" />
            <p>Cleaner cities and reduced landfill overflow.</p>
          </div>
          <div className="col-md-4">
            <FaSeedling size={50} className="icon" />
            <p>Healthier crops through nutrient-rich organic manure.</p>
          </div>
        </div>
      </div>
      <div className="commitment-section text-white text-center">
        <h3 className="fw-bold" style={{color:"#FFF", paddingBottom:"20px"}}>Our Commitment to a Circular Economy.</h3>
        <p>
          We close the loop by turning waste into valuable resources, ensuring nothing goes to
          waste while benefiting farmers, consumers, and the environment.
        </p>
      </div>
    </div>

    {/* science behind starts here*/}
    <div className="science-behind-section container py-5">
      <h2 className="text-muted fw-bold text-center">Science Behind.</h2>
      <div className="row mt-4">
        <div className="col-md-12">
          <p><strong>The Power of the Black Soldier Fly:</strong> The BSF larvae are nature’s best recyclers. They convert organic waste into valuable resources like protein-rich feed, organic compost, and chitosan in just days.</p>
        </div>
      </div>
      <div className="row align-items-start mt-4">
        <div className="col-md-4 text-center">
          <img src={nutrientTable} alt="Nutrient Table" className="img-fluid table-image" />
        </div>
        <div className="col-md-8">
          <p><strong>Nutritional Information of BSF Larvae:</strong></p>
          <p>Black soldier fly larvae are an excellent source of protein and fat. They have a dry matter (DM) protein content ranging from 43 to 51 percent. The amount of fat in the diet is determined by the kind of food and the fat content. Other nutritional sources are included in the table.</p>
      <p className="mt-3">A well-formulated animal feed provides a balanced ratio of proteins and fats. To understand the nutritional profile of BSF larvae, we must first understand their feeding profile. The greater the protein level in the bio-waste profile, the higher the protein content in the BSF larvae.</p>
        </div>
      </div>
      
      <div className="row mt-4">
        <div className="col-md-6">
          <p><strong>Our Process:</strong></p>
          <ul>
            <li>1kg of waste becomes:</li>
            <ul>
              <li>280g organic compost.</li>
              <li>220g protein-rich larvae.</li>
              <li>4g chitosan extract.</li>
            </ul>
          </ul>
        </div>
        <div className="col-md-6">
          <p><strong>What Makes Us Unique:</strong></p>
          <ul>
            <li>Semi-automated systems ensure consistent quality.</li>
            <li>Innovative bio-ponds optimize waste processing.</li>
            <li>Patent-pending methods for efficient protein extraction.</li>
          </ul>
        </div>
      </div>
      <p className="fw-bold mt-4">Why It Works:</p>
      <p>Our technology is fast, effective, and sustainable, making farming better and more eco-friendly.</p>
    </div>
    {/* science behind ends here*/}
    </div>
  )
}

export default Sustainability